import type { MissionColumns } from '@library/types/missions';
import type { TableColumn } from '@library/types/utils';

export const MISSIONS_HEADER: Array<TableColumn<MissionColumns>> = [
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-1/3'
  },
  {
    column: 'optInBy',
    essential: true,
    label: 'Opt in by',
    sortEnabled: true,
    width: 'w-1/5'
  },
  {
    column: 'completeBy',
    essential: true,
    label: 'Complete by',
    sortEnabled: true,
    width: 'w-1/5'
  },
  {
    column: 'payoutAmount',
    essential: true,
    label: 'Payout Amount',
    sortEnabled: true,
    width: 'w-1/5'
  },
  {
    column: 'payoutType',
    essential: true,
    label: 'Payout Type',
    sortEnabled: true,
    width: 'w-1/5'
  }
];

export const CREATE_MISSION_FIXED_CACHE_KEY = 'new-mission';
export const CREATE_MISSION_CONDITIONS_FIXED_CACHE_KEY =
  'new-mission-conditions';
